import BaseFormPage from "../../../../../base/BaseFormPage";
// import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import { findObjectUseCase } from "../../../../../usecases/object";
import Hierarchy from "../../../../../components/common/Hierarchy";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";

export default class WorkFlowHierarchy extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      allPersonnel: [],
      filteredPersonnel: [],
      assignedPersonnel: "",
      request: "",
      approve: "",
      reject: "",
      retrive: "",
      // selectAllDivision: false,
    };
  }
  async componentDidMount() {
    try {
      const limit = 500;
      let skip = 0;
      let hasMore = true;

      while (hasMore) {
        const chunk = await findObjectUseCase().execute("employees", {
          // where: { "roles.0": { $exists: true } },
          keys: [
            "Firstname",
            "Middlename",
            "surname",
            "region",
            "office",
            "division",
            "section",
            "unit",
            "cluster",
          ],
          include: ["employee"],
          limit,
          skip,
        });

        if (!chunk || chunk.length === 0) {
          hasMore = false;
        } else {
          this.setState((prevState) => ({
            allPersonnel: [...chunk, ...(prevState.allPersonnel || [])],
            filteredPersonnel: [
              ...chunk,
              ...(prevState.filteredPersonnel || []),
            ],
          }));

          skip += limit;
          if (this.handleHierarchyFilter() !== undefined) {
            this.handleHierarchyFilter();
          }
        }
      }

      // clearInterval(flushInterval);
      // flushBuffer();
    } catch (e) {
      console.error(e.message || e);
    }

    // Handle existing object data
    const object = this.props.object;
    if (object && Object.keys(object).length > 0) {
      // console.log("PROPSSSSSSS: ", object);
      // Set the state with the existing object data
      this.setState({ ...object }, () => {
        // After state is set, handle the hierarchy filtering
        this.handleHierarchyFilter();
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    // List of state fields to monitor for changes (matching original)
    const selectedFields = [
      "region",
      "office",
      "division",
      "section",
      "unit",
      "cluster",
      "request",
      "approve",
      "reject",
      "retrive",
      "assignedPersonnel",
    ];

    // Check if any of the selected state fields have changed
    const hasSelectionChanged = selectedFields.some(
      (field) => prevState[field] !== this.state[field]
    );

    // Execute this block only if a state field has changed
    if (hasSelectionChanged) {
      // Filter personnel based on hierarchy
      this.handleHierarchyFilter();

      // Trigger the object change callback with the updated state (matching original)
      const { allPersonnel, filteredPersonnel, ...objectData } = this.state;

      // Get filtered user IDs for multiplePersonnel (matching original logic)
      // const idsArray = this.state.filteredPersonnel.map((user) => ({
      //   id: user.id,
      // }));

      this.props.handleObjectChange({
        ...selectedFields.reduce(
          (acc, field) => ({
            ...acc,
            [field]: this.state[field],
          }),
          {}
        ),
        // multiplePersonnel: idsArray,
        // selectAllDivision: this.state.selectAllDivision,
      });
    }

    // If the object prop has changed, refetch the object (matching original)
    if (prevProps.object !== this.props.object) {
      console.log("PREV: ", prevProps);
      this.refetchObject(this.props.object);
    }
  }

  async refetchObject(object) {
    if (object && Object.keys(object).length > 0) {
      console.log("Refetching object: ", object);
      this.setState({ ...object }, () => {
        this.handleHierarchyFilter();
      });
    }
  }

  handleHierarchyFilter() {
    // Build hierarchy object from current state
    const selectedOrg = [
      "region",
      "office",
      "division",
      "section",
      "unit",
      "cluster",
    ];

    const hierarchy = selectedOrg.reduce((acc, field) => {
      const value = this.state[field];
      if (value !== "") {
        acc = { key: field, value: value };
      }
      return acc;
    }, {});

    // Filter personnel based on hierarchy (matching original logic but simplified)
    let filteredPersonnel = this.state.allPersonnel;

    if (hierarchy.key && hierarchy.value) {
      filteredPersonnel = this.state.allPersonnel.filter((employee) => {
        if (!employee) return false;

        // Check if employee matches the hierarchy level
        const employeeValue = employee[hierarchy.key];

        // Handle both string and object comparisons
        if (typeof employeeValue === "object" && employeeValue !== null) {
          return (
            employeeValue.name === hierarchy.value ||
            employeeValue.id === hierarchy.value
          );
        }

        return employeeValue === hierarchy.value;
      });
    }

    this.setState({ filteredPersonnel });
  }

  handleObjectChange(hierarchy) {
    // Update state with hierarchy changes
    this.setState({ ...hierarchy }, () => {
      this.handleHierarchyFilter();
    });
  }

  handleHierarchyChange(field, value) {
    this.setState({ [field]: value });
  }

  render() {
    const isAssignToSelector =
      this.props.assginToRequestor || this.props.selectAllEmployee;
    const taskExecuter = this.props.assginToRequestor
      ? ["Request", "Retrive"]
      : ["Approve", "Reject", "Request", "Retrive"];

    const selectionData = isAssignToSelector
      ? this.state.allPersonnel
      : this.state.filteredPersonnel;
    return (
      <>
        <div className="row" key={1 + 1}>
          {!isAssignToSelector && (
            <div className="mb-4">
              {/* Add selectAllDivision toggle (matching original) */}
              {/* <div className="d-flex justify-content-between mb-2 mt-2 align-items-center">
                <label className="fs-6">Select all division</label>
                <button
                  className="btn btn-primary me-0"
                  type="button"
                  onClick={() => this.toggleAllDivision()}
                >
                  <i
                    className={
                      this.state.selectAllDivision
                        ? "bi bi-toggle-on"
                        : "bi bi-toggle-off"
                    }
                  />
                </button>
              </div> */}

              <Hierarchy
                className="p-1 mb-1"
                object={this.props.object}
                required
                // selectAllDivision={this.state.selectAllDivision}
                handleObjectChange={this.handleObjectChange.bind(this)}
              />

              <label className="mb-2" style={{ fontSize: "14px" }}>
                Assigned Personnel
              </label>

              <SearchSelect
                value={this.state?.assignedPersonnel?.employeeName}
                onClickClear={() =>
                  this.handleHierarchyChange("assignedPersonnel", "")
                }
                focus={true}
                onChange={(value) =>
                  this.handleHierarchyChange("assignedPersonnel", value)
                }
                // disabled={this.state.selectAllDivision}
                options={selectionData.map((item) => {
                  const employeeName = `${item.surname || ""}, ${
                    item.Firstname || ""
                  } ${item.Middlename || ""}`;
                  return {
                    label: employeeName,
                    value: { employeeName, id: item.id },
                  };
                })}
              />
            </div>
          )}
          <hr />

          {taskExecuter.map((item, index) => {
            const field = `${item} Handler`;
            return (
              <div key={item} className="mb-2">
                <label className="mb-2" style={{ fontSize: "14px" }}>
                  {field} <span className="text-danger">*</span>
                </label>
                <SearchSelect
                  required
                  focus={true}
                  value={this.state[item.toLowerCase()]?.employeeName}
                  onClickClear={() =>
                    this.handleHierarchyChange(item.toLowerCase(), "")
                  }
                  onChange={(value) =>
                    this.handleHierarchyChange(item.toLowerCase(), value)
                  }
                  options={
                    selectionData &&
                    selectionData.map((item) => {
                      const employeeName = `${item.surname || ""}, ${
                        item.Firstname || ""
                      } ${item.Middlename || ""}`;
                      return {
                        label: employeeName,
                        value: { employeeName, id: item.id },
                      };
                    })
                  }
                />
              </div>
            );
          })}
        </div>
      </>
    );
  }
}
